module.exports = (__webpack_require__(1))(27);


//////////////////
// WEBPACK FOOTER
// delegated ./src/constants.js from dll-reference girder_plugin_jobs
// module id = 71
// module chunks = 0